import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private getStorageKey(feature: string): string {
    return `${feature}_basicSearchTerm`;
  }

  getSearchTerm(feature: string): string {
    return localStorage.getItem(this.getStorageKey(feature)) || '';
  }

  setSearchTerm(feature: string, term: string): void {
    localStorage.setItem(this.getStorageKey(feature), term);
  }

  clearSearchTerm(feature: string): void {
    localStorage.removeItem(this.getStorageKey(feature));
  }
}
